import React from 'react';
import { AzureCloudAccountAdd } from './AzureCloudAccountAdd';
import { AzureCloudAccountEdit } from './AzureCloudAccountEdit';

/**
 * Azure Cloud Account - Orchestrator Component
 * Routes to Add or Edit mode based on isEditMode prop
 */
export const AzureCloudAccount = ({ isEditMode, ...props }) => {
    return isEditMode ? <AzureCloudAccountEdit {...props} /> : <AzureCloudAccountAdd {...props} />;
};
